import React, { PureComponent } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { media } from 'gipsy-ui'
import { styles } from 'gipsy-misc'
import { getSrc } from 'utils/image'

const propTypes = {
  appTitle: PropTypes.string.isRequired,
  sourcePath: PropTypes.string.isRequired,
  badgeTitle: PropTypes.string,
  badgeColor: PropTypes.string,
  badgeBackground: PropTypes.string,
  appAction: PropTypes.string,
  actionLink: PropTypes.string,
  text: PropTypes.string
}

export class Block extends PureComponent {
  render() {
    const {
      appTitle,
      sourcePath,
      badgeTitle,
      badgeColor,
      badgeBackground,
      appAction,
      actionLink,
      text,
      hideMobile
    } = this.props
    return (
      <BlockContainer blur={!actionLink} hideMobile={hideMobile}>
        <UpperContainer>
          <StyledImage alt={'logo'} src={getSrc(sourcePath)} />
          <TextUpperContainer>
            <AppTitleContainer>
              <AppTitle>{appTitle}</AppTitle>
              {badgeTitle && (
                <Badges color={badgeColor} background={badgeBackground}>
                  {badgeTitle}
                </Badges>
              )}
            </AppTitleContainer>
            <ActionContainer href={actionLink} target="_blank">
              {appAction}
            </ActionContainer>
          </TextUpperContainer>
        </UpperContainer>
        {text && <LowerContainer>{text}</LowerContainer>}
      </BlockContainer>
    )
  }
}

Block.propTypes = propTypes

const BlockContainer = styled.div`
  width: 48%;
  min-height: 120px;
  border-radius: 8px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  padding: 20px;
  justify-content: center;
  opacity: ${props => (props.blur ? 0.5 : 1)};

  ${media['phone-wide']`
  width:100%;
  margin-top:20px;
  ${props => props.hideMobile && `display:None;`}
`}
`

const UpperContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const StyledImage = styled.img`
  width: 48px;
  height: 48px;
  margin-right: 20px;
`

const TextUpperContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const AppTitleContainer = styled.div`
  display: flex;
  margin-bottom: 8px;
`

const AppTitle = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: ${styles.colors.textDarkColor};
  margin-right: 10px;
`

const Badges = styled.div`
  height: 24px;
  width: 42px;
  border-radius: 6px;

  color: ${props => props.color};
  background: ${props => props.background};
  background-color: ${props => props.backgroundColor};
  box-shadow: 12px 12px 40px 0 rgba(100, 63, 219, 0.24);
  font-size: ${styles.fonts.fontSizeXSmall};
  display: flex;
  justify-content: center;
  align-items: center;
`

const ActionContainer = styled.a`
  && {
    color: ${styles.colors.textLightColor};
    font-size: ${styles.fonts.fontSizeSmall};
    text-decoration: underline;
    cursor: ${props => (props.href ? 'pointer' : 'not-allowed')};
  }
`

const LowerContainer = styled.div`
  margin-top: 30px;
  color: ${styles.colors.textLightColor};
  font-size: ${styles.fonts.fontSizeSmall};
`



// WEBPACK FOOTER //
// ./src/features/settings/index.js